import { HomeLocationState } from 'src/states';
import { Store } from '@ngxs/store';
import { inject } from '@angular/core';
import { NavigateToPatients } from 'src/app/states/navigations.actions';
import { NavigationService } from 'src/app/services/navigation.service';
import { SetHomeAccountAsCurrentAccount } from 'src/states/current-account.actions';

export const pscHouseAccountGuard = (): false => {
  const store = inject(Store);
  const navigation = inject(NavigationService);
  const userLocation = store.selectSnapshot(HomeLocationState.userLocation);

  if (userLocation) {
    store.dispatch([new SetHomeAccountAsCurrentAccount(), new NavigateToPatients()]);
    return false;
  }

  if (navigation.getIsBrowserNavigation()) {
    store.dispatch(new NavigateToPatients());
  }
  return false;
};
